import {createBreakpoint} from 'react-use';
import {screens} from 'tailwindcss/defaultTheme';

export const breakpoints = {
    xs: 0,
    sm: Number.parseInt(screens.sm),
    md: Number.parseInt(screens.md),
    lg: Number.parseInt(screens.lg),
    xl: Number.parseInt(screens.xl),
    "2xl": Number.parseInt(screens["2xl"]),
  };

  export const useBreakpoints = createBreakpoint(
    breakpoints
  ) as () => keyof typeof breakpoints;